export default "__VITE_ASSET__CW76zHzG__"